import script from "./SuccessCases.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuccessCases.vue?vue&type=script&lang=ts&setup=true"

import "./SuccessCases.vue?vue&type=style&index=0&id=fa36ad0c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa36ad0c"]])

export default __exports__